var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93045 4.3297L0.986556 18.9154C0.960132 18.9696 0.951759 19.0309 0.96266 19.0902C0.973561 19.1496 1.00316 19.2039 1.04714 19.2452L19.8009 37.2159C19.8542 37.2669 19.9251 37.2955 19.999 37.2955C20.0728 37.2955 20.1437 37.2669 20.197 37.2159L38.9508 19.2463C38.9947 19.205 39.0243 19.1507 39.0352 19.0914C39.0461 19.032 39.0378 18.9707 39.0113 18.9165L32.0675 4.33082C32.045 4.28184 32.009 4.24034 31.9636 4.21129C31.9183 4.18224 31.8655 4.16687 31.8116 4.16701H8.1885C8.13438 4.16634 8.08121 4.18134 8.03542 4.21021C7.98964 4.23908 7.95318 4.28057 7.93045 4.3297Z",
    fill: "#50AF95"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4094 20.4136C22.2748 20.4237 21.5791 20.4652 20.0275 20.4652C18.7933 20.4652 17.917 20.4282 17.6096 20.4136C12.8401 20.2038 9.28007 19.3736 9.28007 18.3795C9.28007 17.3854 12.8401 16.5563 17.6096 16.3431V19.5867C17.9215 19.6092 18.8146 19.6619 20.0488 19.6619C21.5298 19.6619 22.2714 19.6002 22.4049 19.5879V16.3454C27.1643 16.5574 30.7165 17.3877 30.7165 18.3795C30.7165 19.3713 27.1654 20.2016 22.4049 20.4125L22.4094 20.4136ZM22.4094 16.0099V13.1073H29.0515V8.68115H10.9675V13.1073H17.6085V16.0088C12.2107 16.2567 8.15137 17.326 8.15137 18.6072C8.15137 19.8885 12.2107 20.9567 17.6085 21.2057V30.5069H22.4083V21.2024C27.7938 20.9544 31.8463 19.8863 31.8463 18.6061C31.8463 17.326 27.7971 16.2578 22.4083 16.0088L22.4094 16.0099Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.de592a0eaba64fda6c02827b7d0b3227.svg";
export { ForwardRef as ReactComponent };